import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCBoxRadiusModule } from '@wlp/ui-c-box-radius';
import { UiCInputModule } from '@wlp/ui-c-input';
import { UiCHeaderOnboardingModule } from '@wlp/ui-c-header-onboarding';

let UiCAccountTypeComponent = class UiCAccountTypeComponent {
    constructor() {
        this.isBack = true;
        this.back = new EventEmitter();
        this.continue = new EventEmitter();
        this.onCheckCpf = new EventEmitter();
        this.isActive = false;
    }
    ngOnInit() {
        this.typePerson = 'PHYSICAL_PERSON';
        this.isPF = true;
    }
    loadIcon(accountType) {
        let icon;
        switch (accountType) {
            case 'PHYSICAL_PERSON':
            case 'PHYSICAL_PERSON_IDUNICO':
                icon = this.physicalPersonIcon.class;
                break;
            case 'LEGAL_PERSON':
            case 'LEGAL_PERSON_IDUNICO':
                icon = this.legalPersonIcon.class;
                break;
            case 'MEI':
            case 'MEI_IDUNICO':
                icon = this.meiIcon.class;
                break;
            case 'LIBERAL_PROFESSIONAL':
                icon = this.selfEmployedIcon.class;
                break;
            case 'ESCROW_PHYSICAL_PERSON':
                icon = this.physicalPersonIcon.class;
                break;
            case 'ESCROW_LEGAL_PERSON':
                icon = this.legalPersonIcon.class;
                break;
        }
        return icon;
    }
    translateNameType(type) {
        switch (type) {
            case 'Pessoa Física': return 'ONBORDING.V2.FORM.LABEL.PHYSICAL_PERSON';
            case 'Pessoa Jurídica': return 'ONBORDING.V2.FORM.LABEL.LEGAL_PERSON';
            case 'Profissional Liberal': return 'ONBORDING.V2.FORM.LABEL.LIBERAL_PROFESSIONAL';
            case 'MEI': return 'ONBORDING.V2.FORM.LABEL.MEI';
            default: return type;
        }
    }
    changeType(changeType) {
        if (changeType) {
            this.typePerson = changeType.typeFlow;
            this.isPF = false;
            if ((changeType.typeFlow == 'PHYSICAL_PERSON') || (changeType.typeFlow == 'PHYSICAL_PERSON_IDUNICO')) {
                this.isPF = true;
            }
            this.continue.emit({ data: changeType, isPF: this.isPF });
        }
    }
    goBack() {
        this.back.emit();
    }
    goContinue() {
        this.continue.emit(this.typePerson);
    }
    onCpfBlur(data) {
        this.onCheckCpf.emit(data);
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCAccountTypeComponent.prototype, "isBack", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAccountTypeComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAccountTypeComponent.prototype, "description", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAccountTypeComponent.prototype, "primaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAccountTypeComponent.prototype, "secondaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCAccountTypeComponent.prototype, "physicalPersonIcon", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCAccountTypeComponent.prototype, "legalPersonIcon", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCAccountTypeComponent.prototype, "meiIcon", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCAccountTypeComponent.prototype, "selfEmployedIcon", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], UiCAccountTypeComponent.prototype, "listAccountType", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAccountTypeComponent.prototype, "back", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAccountTypeComponent.prototype, "continue", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAccountTypeComponent.prototype, "onCheckCpf", void 0);
UiCAccountTypeComponent = __decorate([
    Component({
        selector: 'ui-c-account-type',
        template: "<div *ngIf=\"listAccountType.length > 0\" class=\"animation-type\">\n\n  <ui-c-header-onboarding\n    [isBack]=\"isBack\" [textBack]=\"'ONBORDING.V2.BUTTON.BACK' | wlpTranslate\"\n    [title]=\"title\" [description]=\"description\"\n    [primaryColor]=\"primaryColor\" [secondaryColor]=\"secondaryColor\"\n    (back)=\"goBack()\"\n  >\n  </ui-c-header-onboarding>\n\n  <ion-row class=\"ion-justify-content-center ion-align-items-center\">\n    <ion-col [sizeXs]=\"5\" [sizeSm]=\"5\" [sizeMd]=\"2\" [size]=\"2\"  *ngFor=\"let accountType of listAccountType\" (click)=\"changeType(accountType)\">\n      <ui-c-box-radius [class]=\"loadIcon(accountType.typeFlow)\"\n        textTitle=\"{{translateNameType(accountType.name) | wlpTranslate}}\" titlePosition=\"bottom\">\n      </ui-c-box-radius>\n    </ion-col>\n  </ion-row>\n</div>\n"
    }),
    __metadata("design:paramtypes", [])
], UiCAccountTypeComponent);

let UiCAccountTypeModule = class UiCAccountTypeModule {
};
UiCAccountTypeModule = __decorate([
    NgModule({
        declarations: [UiCAccountTypeComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            NgxMaskIonicModule,
            IonicModule,
            UiBsTranslateModule,
            FormsModule,
            UiCButtonModule,
            UiCInputModule,
            UiCBoxRadiusModule,
            UiCHeaderOnboardingModule,
        ],
        exports: [UiCAccountTypeComponent]
    })
], UiCAccountTypeModule);

export { UiCAccountTypeComponent, UiCAccountTypeModule };
//# sourceMappingURL=wlp-ui-c-account-type.js.map
